import React, {useState} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import {Inc,Owner,FavSearchCondition} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';
import FavListSearch from './FavListSearch';
import FavListDetail from './FavListDetail';
import FavListItem from './FavListItem';
import FavListType from './FavListType';
import Title from './Title';
import AppBank from './AppBank';

interface FavListProps {
	owner:Owner,
	bank:AppBank,
}
//let p:number = 1;

const FavList = (props:FavListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        tabId:"p1",
        favs:[],
        isLoading:true,
        currentPage:1,
        pager:null,
        cond:Inc.defaultFavSearchCondition(),
    });
    const search = (cond:FavSearchCondition,page:number,newTabId?:string)=>{
        //console.log("search",cond);

        setStates({...states,favs:[],"isLoading":true});
        let tabId = states.tabId;
        if( newTabId ){
            tabId = newTabId;
            page = 1;
        }
        // if( first ){
        //     p = 1;
        // }
        let path = "fav/list";
        if( tabId==="p2" ){
            path = "fav/item";
        } else if( tabId==="p3" ){
            path = "fav/type";
        }
        window.scrollTo(0,0);
        Ajax.search(path,cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,favs:res.favs,cond:cond,currentPage:page,pager:res.pager,isLoading:false,tabId:tabId});
            } else {
                setStates({...states,currentPage:1,"isLoading":false,tabId:tabId});
            }
        });
    }
    function changeTab(event: React.ChangeEvent<{}>, newValue: string) {
        //setStates({...states,tabId:newValue});
        search(states.cond,states.currentPage,newValue);
    }

	const jump = (newPage:number)=>{
		//send(values,p);
		//p = newPage;
		search(states.cond,newPage);
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
		
	return (
		<div id="fav_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="スキ" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        お客さんがあなたの商品のスキをクリックするとここに表示されます。<br/>
                        </div>
                        <Tabs
                            value={states.tabId}
                            onChange={changeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab style={{whiteSpace:"nowrap"}} value="p1" label="詳細表示"/>
                            <Tab style={{whiteSpace:"nowrap"}} value="p2" label="商品別集計" />
                            <Tab style={{whiteSpace:"nowrap"}} value="p3" label="内容別集計" />
                        </Tabs>
                        <Divider style={{marginBottom:'1em'}}/>
                        {states.tabId==="p1" &&
                            <FavListDetail list={states.favs} owner={props.owner} pager={states.pager} jump={jump}/>
                        }
                        {states.tabId==="p2" &&
                            <FavListItem list={states.favs} owner={props.owner} pager={states.pager} jump={jump} selectedTypeId={states.cond.type_id}/>
                        }
                        {states.tabId==="p3" &&
                            <FavListType list={states.favs} owner={props.owner} pager={states.pager} jump={jump} selectedTypeId={states.cond.type_id}/>
                        }


                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <FavListSearch update={search} bank={props.bank} bankKey={"savedFavListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default FavList;
